/* eslint-disable react/jsx-indent */
/* eslint-disable indent */
import React, { useState } from 'react';
import { MdOutlineReportGmailerrorred } from 'react-icons/md';
import {
  Button,
  Flex,
  IconButton,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
  Textarea,
  Tooltip,
  useDisclosure,
  useToast,
} from '@chakra-ui/react';
import { getAuth } from 'firebase/auth';
import { app } from '../../../../configs/firebaseApp';
import { useAppSelector } from '../../../../redux/hooks';
import {
  getSelectedNetworkIndex,
  getSelectedNetworkRequest,
} from '../../../../redux/providerBuilder/selectedNetworkRequest/selectors';
import { sendDataSelectionErrorLogs } from '../../../../utils/logs/send-logs';
import { sendSlackAlert } from '../../../../utils/slack-alert';

interface ReportIssueModalProps {
  searchInstanceInput: string;
  showNew?: boolean;
}

const ReportIssueModal: React.FC<ReportIssueModalProps> = ({
  searchInstanceInput,
  showNew = false,
}) => {
  const auth = getAuth(app);
  const toast = useToast();

  const {
    isOpen: isReportIssueModelOpen,
    onOpen: onReportIssueModelOpen,
    onClose: onReportIssueModelClose,
  } = useDisclosure();

  const [reportIssueText, setReportIssueText] = useState<string>('');

  const selectedNetworkRequest = useAppSelector(getSelectedNetworkRequest);
  const selectedNetworkIndex = useAppSelector(getSelectedNetworkIndex);

  async function sendDataSelectionAlert() {
    const messageBody = {
      issue: reportIssueText,
      userId: auth.currentUser?.uid || '',
      url: selectedNetworkRequest[selectedNetworkIndex]?.url,
      contentType: selectedNetworkRequest[selectedNetworkIndex]?.contentType,
      requestType: selectedNetworkRequest[selectedNetworkIndex]?.requestType,
      searchString: searchInstanceInput,
      requestBody: selectedNetworkRequest[selectedNetworkIndex]?.response?.body,
    };
    // Slack Channel Id
    const channelId = 'C070EGQ9Q94';

    const responseVal = await sendSlackAlert(JSON.stringify(messageBody), channelId);
    sendDataSelectionErrorLogs(messageBody);
    if (responseVal.status === 'success') {
      setReportIssueText('');
      onReportIssueModelClose();
      toast({
        title: 'Data Selection Issue Reported',
        description: 'Thanks for reporting the issue. Our team will look into it',
        status: 'success',
        duration: 3000,
        isClosable: true,
        position: 'top-right',
      });
    } else {
      toast({
        title: 'Error Reporting Issue',
        description: 'Some error occured while reporting the issue',
        status: 'error',
        duration: 2000,
        isClosable: true,
        position: 'top-right',
      });
    }
  }

  return (
    <>
      {showNew ? (
        <Tooltip label="Report an issue with the selecting data" hasArrow placement="top">
          <IconButton
            variant="ghost"
            aria-label="report issue"
            bgColor="black"
            color="white"
            _hover={{ bgColor: 'black', transform: 'scale(1.1)' }}
            onClick={onReportIssueModelOpen}
            icon={<MdOutlineReportGmailerrorred fontSize="1.5rem" />}
          />
        </Tooltip>
      ) : (
        <Text className="x-small-font" ml={1}>
          Can&apos;t select the required data? Click
          <Button
            onClick={onReportIssueModelOpen}
            variant="link"
            colorScheme="black"
            p={0}
            m={0}
            height="auto"
            lineHeight="normal"
            verticalAlign="baseline"
            textDecoration="underline"
            size="sm"
            mx={1}
          >
            here
          </Button>
          to report the issue
        </Text>
      )}

      {isReportIssueModelOpen && (
        <Modal isOpen={isReportIssueModelOpen} onClose={onReportIssueModelClose}>
          <ModalOverlay />
          <ModalContent>
            <ModalHeader>Report The Issue</ModalHeader>
            <ModalCloseButton />
            <ModalBody>
              <Flex>
                <Textarea
                  borderRadius={10}
                  value={reportIssueText}
                  onChange={(e) => setReportIssueText(e.target.value)}
                  placeholder="Explain the issue in breif...."
                />
              </Flex>
            </ModalBody>

            <ModalFooter>
              <Button onClick={onReportIssueModelClose} mr={3}>
                Cancel
              </Button>
              <Button
                colorScheme="blackAlpha"
                bgColor="#000"
                color="#fff"
                onClick={sendDataSelectionAlert}
              >
                Add
              </Button>
            </ModalFooter>
          </ModalContent>
        </Modal>
      )}
    </>
  );
};

export default ReportIssueModal;
